import React from "react";
import img1 from "../../assets/ingridients-images/madhumeh/aswangadha.webp";
import img2 from "../../assets/ingridients-images/madhumeh/daruharidra.webp";
import img3 from "../../assets/ingridients-images/madhumeh/jamunbeej.webp";
import img4 from "../../assets/ingridients-images/madhumeh/kareela.webp";
import img5 from "../../assets/ingridients-images/madhumeh/tejapatra.webp";
import img6 from "../../assets/ingridients-images/madhumeh/mehti.webp";

const data = [
  {
    title: "Ashwagandha",
    img: img1,
    text: "Promotes cartilage health and flexibility",
  },
  {
    title: "Daruharidra",
    img: img2,
    text: "Soothes discomfort & aids recovery",
  },
  {
    title: "Jamun Beej",
    img: img3,
    text: "Supports joint comfort and inflammation balance",
  },
   {
    title: "Karela Beej",
    img: img4,
    text: "Imporves flexibility & joint health",
  },
   {
    title: "Tejpatra",
    img: img5,
    text: "Enhances nutrient absorption",
  },
   {
    title: "Methi",
    img: img6,
    text: "Promotes comfort",
  },

];

const MadhuhemIngredients = () => {
  return (
    <section className="ingredients">
      <h2 className="ingredients-title">
        Key Ingredients for Joint Support
      </h2>

      <div className="ingredients-grid">
        {data.map((item, index) => (
          <div className="ingredient-card" key={index}>
            <div className="pill">{item.title}</div>

            <div className="image-circle">
              <img src={item.img} alt={item.title} />
            </div>

            <p>{item.text}</p>
            <div className="card-shadow"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MadhuhemIngredients;
